import { Form, message, Table, Button, Space } from "antd";
import { useEffect, useState } from "react";
import { fmtDate } from "../../extensions/utils";
import { getTableColumn } from "../../extensions/helper";
import { serverFetch } from "../../server";
import SaleAdd from "../sales/sale-add";
import VisitSaleRowEditor from "../visits/visit-cnt-item";
import { DownOutlined, RightOutlined } from "@ant-design/icons";
import { PaymentAdd } from "../payments";
import dayjs from "dayjs";
import { isMobile } from "../../extensions/design";
import ClientItemSale from "./client-item-sale"
import { Scan } from "../../controls";

const ClientSales = ({ id, exposeOnRefresh }) => {
  const [form] = Form.useForm();
  const [itmSalesList, setItmSalesList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saleAdd, setSaleAdd] = useState(false);
  const [showPayment, setShowPayment] = useState(false);
  const [selected, setSelected] = useState([]);
  const [item, setItem] = useState({ vid: 0 });

  const getData = () => {
    if (id) {
      setLoading(true);
      serverFetch(`client/${id}`)
        .then((data) => {
          if (data.createdOn) data.createdOn = dayjs(data.createdOn);
          if (data.dateBirth) data.dateBirth = dayjs(data.dateBirth);
          data.vid = data.vid === 1;
          setLoading(false);
          setItem(data);
          form.setFieldsValue(data);
        })
        .catch((e) => {
          setLoading(false);
          message.error(e.userName);
        });
    }
  };
  useEffect(getData, [form, id]);  
  const getSalesData = () => {
    setLoading(true);
    serverFetch(`sale/listbyclient/${id}?vids=${0}&vids=${1}&vids=${4}`)
      .then((data) => {
        const activeSales = Array.isArray(data) ? data.filter(item => !item.deleted) : [];
        console.log(activeSales)
        setItmSalesList(activeSales);
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        message.error(e.userMessage || "Ошибка загрузки");
      });
  };

  const onRowClick = (record) => {
    const key = record.id;
    setSelected(prevKeys => prevKeys.includes(key) ? prevKeys.filter(k => k !== key) : [key]);
  }
  
  const onItemClose = (refresh) => {
    setSelected([]);
    if (refresh) {
      getSalesData();
      getData();
    }
  }
  const onClosePayment = (refresh) => {
    setShowPayment(false);
    refresh && getSalesData();
    refresh && getData()
  }

  const onSale = () => setSaleAdd(true);

  const onUpdate = () => {
    getSalesData(); 
    getData();
  }

  const onCloseSaleAdd = (refresh) => {
    setSaleAdd(false);
    refresh && getSalesData();
    refresh && getData();
  }

  useEffect(() => {
    getSalesData();
  }, []);

  useEffect(() => {
    if (exposeOnRefresh) {
      exposeOnRefresh(() => onUpdate);
    }
  }, [exposeOnRefresh]);
  
  const columns = [
    getTableColumn("id", "#", { type: "number", defaultSortOrder: "descend" }, itmSalesList),
    getTableColumn("visitId", "Визит", { type: "number", width: 65 }, itmSalesList),
    getTableColumn("productName", "Товар", itmSalesList),
    getTableColumn("price", "Цена", { type: "number" }, itmSalesList),
    getTableColumn("discountPrc", "Скидка", { type: "number" }, itmSalesList),
    getTableColumn("syma", "Сумма", { type: "number" }, itmSalesList),
    getTableColumn("createdOn", "Продан", { type: "date", formatFn: fmtDate }, itmSalesList),
    getTableColumn("userName", "Исполн.", { type: "string" }, itmSalesList),
    getTableColumn("debet", "Долг", { type: "number", width: 70 }, itmSalesList),
  ];

  const renderedTable = !isMobile ? <>
    <Form form={form} labelCol={{ span: 6 }} wrapperCol={{ span: 24 }} colon={false} disabled={loading}>
        <Space style={{ marginBottom: "8px" }}>
          <Button className="sport-btn" onClick={onSale}>Продать</Button>
          <Button className="sport-btn" onClick={onUpdate}>Обновить</Button>
          {(!item.clientId && item.dolg) ? <Button onClick={() => setShowPayment(true)} className="dolg-button">Долг {item.dolg}</Button> : null} 
        </Space>
      <Table dataSource={itmSalesList} loading={loading} columns={columns} size="small" className="table-item" pagination={false} rowKey="id"
      expandable={{
        expandedRowRender: (record) => <VisitSaleRowEditor onClose={onItemClose} itemDefault={record} />, expandedRowKeys: selected,
        onExpand: (expanded, record) => setSelected(expanded ? [record.id] : []),
        expandIcon: ({ expanded, onExpand, record }) => expanded ? 
        <DownOutlined onClick={(e) => {onExpand(record, e); e.stopPropagation();}} /> : 
        <RightOutlined onClick={(e) => {onExpand(record, e); e.stopPropagation();}} />,
        rowExpandable: () => true,
        className: "cl-abons-expandable",
      }}
      onRow={record => ({ onClick: () => onRowClick(record) })}
      rowSelection={{ type: 'radio', selectedRowKeys: selected, renderCell: checked => <div className={checked ? "list-indicator" : ""} /> }}
      />
      {saleAdd && <SaleAdd visitId={null} clientId={id} onClose={onCloseSaleAdd} activeBtns={["Товар", "Услуга", "Сертификат"]}/>}
      {showPayment && <PaymentAdd clientId={item.id} visitId={null} onClose={() => onClosePayment(true)}/>}
    </Form>
  </> : <>
    <Form form={form} colon={false} disabled={loading} style={{marginTop: "8px"}} className="client-form-sale-layout">
      <div className="client-form-footer">
        {(!item.clientId && item.dolg) ?
          <Button style={{width:"49.5%"}} onClick={() => setShowPayment(true)} className="sport-btn-mobile-pay">
            Оплатить {item.dolg}
          </Button>
        : <></>}
        <Button style={(!item.clientId && item.dolg) ? {width: "49.5%"} : {width: "100%"}}onClick={onSale}>Продать</Button>
      </div> 
      {(itmSalesList.length === 0 && !loading) ?
        <div style={{ textAlign: "center", marginTop: "20px", fontSize:"14px" }}>Нет данных
        </div> : <></>}
        <div className="client-items client-items-scroll" style={{ overflowY: "scroll", overflowX: "clip", marginTop: "4px"}}>
          {itmSalesList.map(item => 
          <ClientItemSale item={item} key={item.id} expanded={selected.includes(item.id)} onItemClose={onItemClose}
            onExpand={() =>
              setSelected(prev =>
                prev.includes(item.id) ? [] : [item.id]
              )
          }/> )}
      </div>
      {saleAdd && <SaleAdd visitId={null} clientId={id} onClose={onCloseSaleAdd} activeBtns={["Товар", "Услуга", "Сертификат"]}/>}
      {showPayment && <PaymentAdd clientId={item.id} visitId={null} onClose={() => onClosePayment(true)}/>}
    </Form>
    
    </>


const onScan = value => {
  setLoading(true);
  let barcode = value;
  if (barcode.length > 15 && barcode.startsWith("01")) barcode = barcode.slice(3, 16);
  serverFetch(`product/GetByBarcode?barcode=${barcode}`)
    .then(data => {
      if (data) {
        const item = {
          // productName: record.name,
          qty: 1,
          clientId: id,
          productId: data.id,
          price: data.expPrice,
          deleted: false,
          status: 0,
          syma: data.expPrice,
        }
        serverFetch("sale", {method: "POST", bodyData: item})
          .then(() => {
            setLoading(false);
            getData();
            getSalesData();
          })
          .catch(e => {
            setLoading(false);
            message.useMessage(e.userMessage);
          });
      }
      else {
        setLoading(false);
        message.error('Товар не найден');
      }
    })
    .catch(e => {
      setLoading(false);
      message.error(e.userMessage);
    })
}


  return (
    <>
    {renderedTable}
    <Scan onScan={onScan}/>
    </>
  );
};

export default ClientSales;
